import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http'
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SitedataService {
  baseApiUrl: string;
  httpOptions: object;
  constructor(private http:HttpClient) {
    this.baseApiUrl = environment.baseApiUrl;
  }

  getOpenGraphData(link) {
    let endPoint = this.baseApiUrl + '/ogs';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    let data = {'linkUrl': link};
    return this.http.post(endPoint, data, this.httpOptions).pipe(
      catchError(err => this.handleError(err))
    );

  }

  getUrlContent(link) {
    let endPoint =link;
    this.httpOptions = {
      // headers: new HttpHeaders({
      //   'Content-Type':  'application/json',
      // })
    };
    // let data = {'linkUrl': link};
    return this.http.get(endPoint, this.httpOptions).pipe(
      catchError(err => this.handleError(err))
    );
  }

  getClearText(link) {
    let endPoint = this.baseApiUrl + '/extract-cleartext';
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
      })
    };
    let data = {'linkUrl': link};
    
    return this.http.post(endPoint, data, this.httpOptions).pipe(
      catchError(err => this.handleError(err))
    );
  }

  private handleError(error: HttpErrorResponse) {
    let errMsg = (error.message) ? error.message : error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      
      // console.error(
      //   `Backend returned code ${error.status}, ` +
      //   `body was: ${error.error}`);
    }
    
    // return an observable with a user-facing error message
    // return Observable.throw(error);
    return throwError(error);
    // return false;
  };
}
